module.exports = __webpack_public_path__ + "img/logo_one-platform-for-drak-background.e306d38.e306d38a.png";